import * as types from "../../mutationTypes";
import deliveryNoteService from "services/deliveryNoteService";

const actions = {
  async setFilterDate ({ commit }, date) {
    await commit(types.DELIVERY_NOTE_DATE_FILTER, { date });
  },
  async setFilterCustomer ({ commit }, customerId) {
    await commit(types.DELIVERY_NOTE_CUSTOMER_FILTER, { customerId });
  },
  async findByFilter ({ commit, state, dispatch }) {
    await commit(types.DELIVERY_NOTE_LIST_CLEAR);
    dispatch('app/loadingDataEnable', 'deliveryNotes', {root: true});
    const deliveryNotes = await deliveryNoteService.findByFilter(state.filter);
    await commit(types.DELIVERY_NOTE_LIST, {
      items: deliveryNotes || []
    });
    dispatch('app/loadingDataDisable', 'deliveryNotes', {root: true});
  }
};

export default actions



// WEBPACK FOOTER //
// ./client/store/modules/deliveryNote/deliveryNoteActions.js